// 本地
export const local = {
  baseURL: 'http://127.0.0.1:8113',
  path: 'http://127.0.0.1:8115/#/login', //IDM登录界面
  port: 'http://127.0.0.1:5173/#/portalhome', //IDM门户页
  qian: 'http://127.0.0.1:8115/#/', //WMS前端自跳转
  IDMapi: 'http://127.0.0.1:8113/WMS/redirect', //idm接口
}

// 云上
export const cloud = {
  baseURL: 'http://120.46.209.88:8113',
  path: 'http://120.46.209.88:3455/#/login', //IDM登录界面
  port: 'http://120.46.209.88:5173/#/portalhome', //IDM门户页
  qian: 'http://120.46.209.88:3455/#/', //WMS前端自跳转
  IDMapi: 'http://120.46.209.88:8113/WMS/redirect', //idm接口
}
